export default (props) => (
  /**
   * Ícone polígono na listagem de classes da classificação por atributo
   * quando camada é do tipo polígono.
   * Cor parametrizada.   
   */
   <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.56843 17.3751L0.339844 8.7774L6.48107 0.179688L17.5353 11.2339L6.56843 17.3751Z"
      fill={props.fill || 'currentColor'}
    />
  </svg>
);
